<script setup lang="ts">
import type { HeadingProps } from "./heading.types";
import { useHeading } from "./useHeading";

defineOptions({ name: "EHeading", inheritAttrs: false });

const props = withDefaults(defineProps<HeadingProps>(), {
  as: "h2",
});

const { classes, titleText, showLeading, showDefault, showTrailing, leadingIconName, trailingIconName } = useHeading({
  props,
});
</script>

<template>
  <component
    :is="as"
    part="base"
    exportparts="leading-icon,trailing-icon"
    :class="classes"
    class="e-heading"
    v-bind="$attrs"
  >
    <span v-show="showLeading" part="leading" class="e-heading-leading">
      <slot name="leading">
        <e-icon v-if="leadingIconName" exportparts="base:leading-icon" :name="leadingIconName" />
      </slot>
    </span>
    <span v-show="showDefault" part="content" class="e-heading-content">
      <slot>{{ titleText }}</slot>
    </span>
    <span v-show="showTrailing" part="trailing" class="e-heading-trailing">
      <slot name="trailing">
        <e-icon v-if="trailingIconName" exportparts="base:trailing-icon" :name="trailingIconName" />
      </slot>
    </span>
  </component>
</template>

<style>
:host {
  display: contents;
}
</style>
